import type { FC } from 'react';

import { Box, Typography } from '@mui/material';
import { tss } from 'tss-react/mui';

type Props = {
  label: string;
  value: string;
};

const useStyles = tss.create(({ theme }) => ({
  label: {
    fontWeight: 500,
  },
  root: {
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
    'borderRadius': theme.shape.borderRadius,
    'display': 'flex',
    'gap': theme.spacing(2),
    'justifyContent': 'space-between',
    'paddingBottom': theme.spacing(0.5),
    'paddingLeft': theme.spacing(1),
    'paddingRight': theme.spacing(1),
    'paddingTop': theme.spacing(0.5),
    'transition': theme.transitions.create('background-color'),
  },
}));

export const DataRow: FC<Props> = ({ label, value }) => {
  const { classes } = useStyles();
  return (
    <Box className={classes.root}>
      <Typography className={classes.label} variant="body2">
        {label}
      </Typography>
      <Typography variant="body2">{value}</Typography>
    </Box>
  );
};
